import type { FormItem } from '#/common/components/Form';
import allFields, { type SyncHistoryFormRecord } from '#/modules/admin/syncHistory/utils/fields';

const fields: FormItem<SyncHistoryFormRecord>[] = [
  {
    cssClass: 'tmm-section',
    colCount: 4,
    caption: 'Sync History Details',
    items: [
      { ...allFields.number, colSpan: 1 },
      { ...allFields.source, colSpan: 1 },
      { ...allFields.type, colSpan: 1 },
      { ...allFields.status, colSpan: 1 },
      { ...allFields.syncedCount, colSpan: 1 },
      { ...allFields.organizationName, colSpan: 1 },
      { ...allFields.syncedByUserName, colSpan: 1 },
    ],
  },
  {
    cssClass: 'tmm-section',
    colCount: 4,
    caption: 'Timing',
    items: [
      { ...allFields.createdAt, colSpan: 1 },
      { ...allFields.updatedAt, colSpan: 1 },
      { ...allFields.startedAt, colSpan: 1 },
      { ...allFields.finishedAt, colSpan: 1 },
    ],
  },
  {
    cssClass: 'tmm-section',
    colCount: 4,
    caption: 'Result',
    items: [{ ...allFields.result, colSpan: 4 }],
  },
];

export default fields;
